import { api } from '../lib/api'

export async function unlockPost(postId: number, opts?: { idempotencyKey?: string }) {
  const headers: Record<string, string> = {}
  if (opts?.idempotencyKey) headers['Idempotency-Key'] = opts.idempotencyKey
  const { data } = await api.post<{ unlocked: boolean; new_balance: string | null; post: any }>(
    `/api/posts/${postId}/unlock/`,
    {},
    { headers }
  )
  return data
}

